import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import OperateTabs_3 from "examples/Tabs/OperateTabs_3";

function Operate_2() {
  return (
    <DashboardLayout>
      <OperateTabs_3 />
    </DashboardLayout>
  );
}

export default Operate_2;